import Api from '@/services/Api'

const HEADERURL = 'inv/req_traslado/';
const ACTION_ADD_DETAIL = 'agregar_detalle';
const ACTION_DELETE_DETAIL = 'eliminar_detalle';
const ACTION_CERRAR = 'cerrar';
const ACTION_ANULAR = 'anular';
const ACTION_ABRIR = 'abrir';
const ACTION_GENERAR_SALIDA = 'generar_salida';
const ACTION_REPORTE_PDF = 'pdf';

export default {

    fetch(params) {

        return Api().get(HEADERURL, {

            params: params

        });

    },

    getById(codigo) {

        return Api().get(`${HEADERURL}${codigo}`);

    },

    save(params) {
        if (params.id != null) {
            return Api().put(`${HEADERURL}${params.id}` + '/', params);
        }
        return Api().post(HEADERURL, params);

    },

    addDetail(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACTION_ADD_DETAIL}/`, params);

    },

    deleteDetail(id, params) {

        return Api().post(`${HEADERURL}${id}/${ACTION_DELETE_DETAIL}/`, params);

    },

    abrir(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_ABRIR}/`);

    },

    cerrar(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_CERRAR}/`);

    },

    anular(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_ANULAR}/`);

    },

    generar_salida(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_GENERAR_SALIDA}/`);

    },

    pdf(id, params) {

        return Api().post(`${HEADERURL}${id}/${ACTION_REPORTE_PDF}/`, params);

    },

    validarProductoExistente(params) {
        return Api().post(`${HEADERURL}validar_producto_duplicado/`, params, {
            timeout: 10000, // 10 segundos de timeout
            // headers: {
            //     'Cache-Control': 'no-cache'
            // }
        });
    },

}